// extracted by mini-css-extract-plugin
export default {"table":"PrizeStats_table__Vehb5","searchbar":"PrizeStats_searchbar__Ug66p","sort":"PrizeStats_sort__cqO8U"};